// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"f415eb85","195":"5c8e44af","289":"d22319e2","293":"aa71c3fa","410":"48ea600d","639":"78a9563b","802":"70b140c9","842":"35fad74b"}[chunkId] + ".chunk.js";
};